<template>
    <div :class="[(!this.$root.settings.showFilter && !constrainWidth) ? 'noFilter' : '', 'pricelistContainer']">
        <actionCodeInput class="hideInDesktop" v-if="displayActionCodeInput && !$store.state.pointshop"></actionCodeInput>
        <div class="pricelist">
            <div class="activeFilter" v-show="filterPillList.length > 0">
                <transition-group name="bounce" :duration="{ enter: 300, leave: 0 }">
                    <div class="filterPillContainer" v-for="(filter, index) in filterPillList" :key="filter.name+index">
                        <div @click="removeFromFilter(index)" class="filterPill">
                            <p>{{filter.name}}</p>
                            <i class="fas fa-times"></i>
                        </div>
                    </div>
                </transition-group>
                <div class="filterPillContainer">
                    <div @click="removeFromFilter('x')" class="filterPill clearPill">
                        <p>{{this.$root.language.wsm_Reset}}</p>
                        <i class="fas fa-times"></i>
                    </div>
                </div>
            </div>
            <contentloaders :view="view"></contentloaders>
            <h3 v-if="(((typeof $store.state.priceList[0] != 'undefined' && $store.state.priceList[0].globalProducts.length == 0)) && (typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0) && !$store.state.loading)" class="noResult">{{this.$root.language.wsm_noResult}}</h3>
            <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length == 0 && view == 'list' ? view : '', view == 'grid' ? 'inlineClass' : '', $store.state.loading ? 'loading' : '']" v-for="(attr, index) in priceList" :key="index">
                <div class="productCat" v-if="(typeof attr.name != 'undefined')">{{attr.name}}</div>
                <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : '']" v-for="(product, index2) in attr.globalProducts" :key="index2">
                    <product :product="product" :quantity="0" :view="view"  :backorder="backorder"></product>
                    <hr v-if="((index2+1) != attr.globalProducts.length) && view == 'list'">
                </div>
            </div>
        </div>
        
        <div v-if="($store.state.searchResult.show && $store.state.filter.length > 0) || (typeof $store.state.searchResult.result[0] != 'undefined' && $store.state.searchResult.result[0].globalProducts.length == 0 && $store.state.searchResult.show)" class="pricelist">
            <h3 v-if="$store.state.searchResult.show && $store.state.searchResult.result[0].globalProducts.length == 0 && !$store.state.loading" class="noResult">{{this.$root.language.wsm_noResult}}</h3>
            <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : 'list', $store.state.loading ? 'loading' : '']" v-for="(attr, index2) in priceList" :key="index2">
                <div class="productCat" v-if="(typeof attr.name != 'undefined')">{{attr.name}}</div>
                <div :class="[typeof $store.state.filter != 'undefined' && $store.state.filter.length > 0 || view == 'grid' ? view : 'list']" v-for="(product, index3) in attr.globalProducts" :key="index3">
                    <product :product="product" :quantity="0" :view="view" :backorder="backorder" ></product>
                    <hr v-if="((index3+1) != attr.globalProducts.length) && view == 'list'">
                </div>
            </div>
        </div>

        <!-- Legal info: shown on mobile below the product list -->
        <div class="mobileLegalInfo" v-if="$store.state.mobile && $root.language.wsm_legalInfoHeading != 'false'">
            <p class="legalInfoHeading" v-html="$root.language.wsm_legalInfoHeading"></p>
            <p class="legalInfoBody" v-html="$root.language.wsm_legalInfoBody"></p>
        </div>
    </div>
</template>

<script>

import settingsComponent from './settings'

import product from './product.vue'
import contentloaders from './contentloaders'
import actionCodeInput from './actionCodeInput.vue'


export default {
    name: "pricelist",
    props: {
        view: {
            type: String,
            default: 'list',
        },
        // When the CMS left column is hosted in the sidebar, keep the 71% list width.
        constrainWidth: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        contentloaders,
        product,
        settingsComponent,
        actionCodeInput,
    },
    
    data() {
        return {
            showPill: false,
            filterPillList: [],
            grid: 3,
            backorder: this.$root.backorder,
            showActionCodeInput: ['en_IE', 'de_DE']
        };
    },
    created() {
        this.$store.state.pointshop = this.$root.pointshop
        //Let the filter handle getting the pricelist if there's a parameter called filter
        var filter;
        var parser = document.createElement('a'); //Create a container       
        parser.href = window.location.href; //Get the whole URL       
        var parameter = parser.search; //search for parameter
        var value = parser.search;
        parameter = parameter.substr(parameter.indexOf("?") + 1);
        parameter = parameter.substr(0, parameter.indexOf('='));

        var showAndHideAttrCollection = [this.$root.settings.showCat, this.$root.settings.hideCat]; //create a colection of selected and blacklisted attributes;      

        if (parameter != 'filter') {
            this.$store.dispatch("getPriceList", showAndHideAttrCollection);// dispatch selected Attributes array, and the balcklisted AttributeValues to the store
        }
        this.filterPillList = this.$store.state.priceListFilterPills;
    },
    mounted() {
        this.$store.subscribe((mutation, state) => {
            switch (mutation.type) {
                case 'setFilter':
                    this.filterPillList = this.$store.state.priceListFilterPills;
                    break;
                case 'applySearchResult':
                    this.filterPillList = [];
                    state.priceListFilterPills = [];
                    break;
            }
        })
    },
    watch: {
        view: function() {
            this.$nextTick().then(() => {
                this.$store.dispatch('screenSize', (window.innerWidth <= 700))
            })
        },
    },
    methods: {
        //gets called when the user click on the "Remove selected filters" button
        removeFromFilter: function(index) {
            var checkedArray = [];
            if (index == 'x') {
                this.filterPillList = [];
                this.$store.state.priceListFilterPills = [];
            } else {
                this.filterPillList.splice(index, 1);
                this.$store.state.priceListFilterPills.forEach(el => {
                    checkedArray.push(el.attributeValueId)
                })
            }
            this.$store.dispatch("getPriceList", [checkedArray, this.$root.settings.hideCat]);
        }
    },
    computed: {
        locale: function() {
            return window.locale
        },
        itemsComputed: function(){
            let arrayList = [];
            
            for(let n = 0; n< 10; n++){
                let tempObj = {};
                tempObj['uid'] = 'unique_'+n;
                tempObj['text'] = 'text-Text'+n;
                arrayList.push(tempObj);
            }
            return arrayList;
        },
        priceList: function() {
            if (this.$store.state.searchResult.show) {
                return this.$store.state.searchResult.result
            } else {
                return this.$store.getters.priceList;
            }
        },
        displayActionCodeInput: function(){
            return this.showActionCodeInput.includes(this.locale)
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#integrationTest .pricelist {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    text-align: left;
}

.pricelistContainer {
    display: inline-block;
    vertical-align: top;
    margin: 0 auto;
    text-align: center;
    width: 71%;
    float: right;
}

.loading {
    transition: all 0.3s ease-in-out;
    opacity: 0.3;
}

.activeFilter {
    min-height: 50px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    margin-left: 17px;
    margin-bottom: 16px;
    .filterPillContainer {
        width: auto;
        display: inline-block;
    }
    .filterPill {
        width: auto;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #004570;
        padding: 5px 10px 5px 12px;
        border-radius: 20px;
        color: white;
        box-shadow: 3px 2px 7px 0px #cbcbcb;
        cursor: pointer;
        min-width: 41px;
        margin-right: 8px;
        margin-top: 10px;
        &:hover {
            background: #0c659d;
        }
        p {
            color: white;
            display: block;
            font-size: 0.8em;
            margin: 0;
        }
        i {
            color: white;
            font-size: 0.7em;
        }
    }
    .clearPill {
        background: #7caf63;
        &:hover {
            background: #94ce77;
        }
    }
}

.noFilter.pricelistContainer {
    width: 100%;
    .inlineClass {
        grid-template-columns: repeat(4, 1fr);
    }
}

.noResult {
    text-align: center;
    font-size: 3em;
    color: #a8a8a8;
    display: block;
    text-align: center;
    margin-top: 33px;
}

.inlineClass {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}


.productCat {
    background: #004570;
    padding: 7px;
    color: white;
    text-align: left;
    width: 100%;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
    clear: both;
    grid-column: 1 / -1;
    box-sizing: border-box;
}

.grid {
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
}

.list {
    width: 100%;
    display: block;
    text-align: center;
    margin: 0 auto;
    transition: all 0.2s ease-in-out;
    hr {
        width: 96%;
        border: 1px solid #eaeaea;
    }
}

.attrHeader {
    background: #cbe9fc;
    color: #004570;
    text-align: left;
    padding: 10px;
    padding-left: 17px;
    border-radius: 4px;
    font-size: 1.3em;
    font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

    {
    opacity: 0;
}

.bounce-enter-active {
    animation: bounce-in .3s;
}

.bounce-leave-active {
    animation: bounce-in 0s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.productShopMoble {
    .pricelistContainer {
        width: 100%;
    }
    .inlineClass {
        grid-template-columns: 1fr;
    }
    /* Tighter pills on mobile so they wrap neatly */
    .activeFilter {
        margin-left: 0;
        padding: 0 4px;
        margin-bottom: 16px;
    }
    .activeFilter .filterPill {
        margin-right: 5px;
        margin-top: 6px;
        padding: 4px 8px 4px 10px;
        font-size: 0.85em;
    }
}


@media screen and (max-width: 900px) {
    .inlineClass {
        grid-template-columns: repeat(2, 1fr);
    }
    .noFilter.pricelistContainer {
        .inlineClass {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}

@media screen and (max-width: 700px) {
    .noFilter.pricelistContainer {
        .inlineClass {
            grid-template-columns: repeat(2, 1fr);
        }
    }
}

@media screen and (max-width: 650px) {
    .inlineClass {
        grid-template-columns: 1fr;
    }
    .noFilter.pricelistContainer {
        .inlineClass {
            grid-template-columns: 1fr;
        }
    }
}

.mobileLegalInfo {
    width: 100%;
    margin-top: 24px;
    text-align: left;
    .legalInfoHeading {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        background-color: #004570;
        border: 1px solid #004570;
        color: white;
        padding: 3%;
        margin: 0;
    }
    .legalInfoBody {
        padding: 5% 3% 9%;
        border: 1px solid #d5d5d5;
    }
}

 .turquoiseTheme{
    .productCat{
        background: #418a90;
    }
 }
</style>
